<script setup lang="ts">
import { classname } from '@/js/utils.ts';

defineProps<{
  name: string
  url: string
  image: string
  sku: string
  price: string
  oldPrice: string | null
}>();

const cn = classname('product-search-item');
</script>

<template>
  <a :href="url" :class="cn()">
    <picture :class="cn('picture')">
      <img :src="image" alt="" loading="lazy" width="100" height="100">
    </picture>
    <span :class="cn('inner')">
      <span :class="cn('name')">
        {{ name }}
      </span>
      <span :class="cn('sku')">
        {{ sku }}
      </span>
      <span :class="cn('prices')">
        <span v-if="oldPrice" :class="cn('old-price')">{{ oldPrice }}</span>
        {{ price }}
      </span>
    </span>
  </a>
</template>

<style lang="scss">
.product-search-item {
  display: grid;
  column-gap: 8px;
  grid-template-columns: 80px 1fr;
  padding: 16px;
  color: #000;
  text-decoration: none;

  &:not(:last-child) {
    border-bottom: 1px solid #ced2df;
  }

  &__picture {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    aspect-ratio: 1 / 1;

    img {
      display: block;
      max-width: 100%;
      max-height: 100%;
      height: auto;
    }
  }

  &__inner {
    display: grid;
    grid-template-areas: 'name name' 'sku prices';
    grid-template-columns: auto 1fr;
    grid-template-rows: auto 1fr;
    gap: 8px;
    align-items: center;
    font-size: 14px;
    line-height: 1.2;
  }

  &__name {
    grid-area: name;
    font-weight: 400;
    transition: color var(--transition);
    word-wrap: break-word;
  }

  &:hover &__name {
    color: var(--light-accent-color);
  }

  &__sku {
    grid-area: sku;
    font-size: 14px;
    color: #aeaeae;
  }

  &__prices {
    grid-area: prices;
    gap: 8px;
    font-weight: 500;
    text-align: right;
  }

  &__old-price {
    font-weight: 300;
    text-decoration: line-through;
    color: #6b6b6b;
    letter-spacing: 0;
  }

  @media (max-width: 992px) {
    grid-template-columns: 48px 1fr;

    &__prices {
      font-size: 22px;
    }
  }
}
</style>
